import React, { useRef, useState, useEffect } from "react";
import ReactToPrint from "react-to-print";
import { StudentPrintable } from "./PrintAllStudentResults"; // Import StudentPrintable component
import "./PrintActionCard.css";

const ReportCardPrintActionCard = ({
  cardPosition,
  handleCloseCard,
  overviewRef,
  detailedRef,
  detailedView,
  studentResults,
  toggleScoreType,
  assessmentResultsByStudent,
  teacherid,
  schoolid,
  students,
  teachers,
  classDetails,
  currentViewRef,
  classNotes,
}) => {
  const printCardRef = useRef(null);
  const studentPrintableRef = useRef(null); // Create a ref for StudentPrintable

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    // Reset search query and selected student IDs when students prop changes
    setSearchQuery("");
    setSelectedStudentIds([]);
    setSelectAll(false);
  }, [students]);

  useEffect(() => {
    if (currentViewRef) {
      console.log("Current View:", currentViewRef.current); // Example: Log the current view
    }
  }, [currentViewRef]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleStudentSelect = (studentId) => {
    setSelectedStudentIds((prevSelected) =>
      prevSelected.includes(studentId)
        ? prevSelected.filter((id) => id !== studentId)
        : [...prevSelected, studentId]
    );
    setSearchQuery(""); // Clear the search query after selection
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStudentIds([]);
    } else {
      setSelectedStudentIds(students.map((student) => student.id));
    }
    setSelectAll(!selectAll);
  };

  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const selectedStudents =
    selectedStudentIds.length > 0
      ? students.filter((student) => selectedStudentIds.includes(student.id))
      : students;

  return (
    <div
      ref={printCardRef}
      className="action-card"
      style={{
        position: "absolute",
        top: `${cardPosition.top}px`,
        left: `${cardPosition.left}px`,
        zIndex: 1000,
        width: "320px",
      }}
    >
      <div className="action-card-header">
        <p className="action-header">Print</p>
        <button onClick={handleCloseCard} className="close-button">
          ✕
        </button>
      </div>

      <div className="action-card-body">
        <ReactToPrint
          trigger={() => (
            <button className="blue-action-button">Current View</button>
          )}
          content={() => {
            console.log("Printing Content Ref:", currentViewRef.current);
            return currentViewRef.current;
          }}
          onBeforeGetContent={() => {
            console.log(
              "Before Print: Active Accordion Ref:",
              currentViewRef.current
            );
          }}
        />
        <div className="action-search-bar">
          <img
            src={process.env.PUBLIC_URL + "/assets/imgs/search-outline.svg"}
            alt="Search"
            className="search-icon"
          />
          <input
            type="text"
            placeholder="Search student"
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              background: "transparent",
            }}
          />
        </div>

        {searchQuery && (
          <div className="search-results">
            {filteredStudents.map((student) => (
              <div
                key={student.id}
                className="search-result-item"
                onClick={() => handleStudentSelect(student.id)}
                style={{
                  backgroundColor: selectedStudentIds.includes(student.id)
                    ? "#e0e0e0"
                    : "transparent",
                }}
              >
                {student.name}
              </div>
            ))}
          </div>
        )}
        <div className="select-all-container">
          <input
            type="checkbox"
            id="selectAll"
            name="selectAll"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          <label htmlFor="selectAll">Select All Students</label>
        </div>
        {selectedStudentIds.length > 0 && (
          <div className="selected-students">
            {selectedStudentIds.map((studentId) => {
              const student = students.find(
                (student) => student.id === studentId
              );
              return (
                <div key={studentId} className="selected-student-item">
                  <input
                    type="checkbox"
                    checked={selectedStudentIds.includes(studentId)}
                    onChange={() => handleStudentSelect(studentId)}
                  />
                  <label>{student.name}</label>
                </div>
              );
            })}
          </div>
        )}
        <div className="action-button-container">
          <ReactToPrint
            trigger={() => (
              <button
                className={`blue-action-button ${
                  selectedStudentIds.length === 0 ? "disabled-button" : ""
                }`}
                disabled={selectedStudentIds.length === 0}
              >
                Simple
              </button>
            )}
            content={() => overviewRef.current}
            onBeforeGetContent={() => {
              console.log("Before Print: Overview Ref:", overviewRef.current);
            }}
          />
          <ReactToPrint
            trigger={() => (
              <button
                className={`blue-action-button ${
                  selectedStudentIds.length === 0 ? "disabled-button" : ""
                }`}
                disabled={selectedStudentIds.length === 0}
              >
                Detailed
              </button>
            )}
            content={() => studentPrintableRef.current} // Reference StudentPrintable component
            onBeforeGetContent={() => {
              console.log(
                "Before Print: Detailed Ref:",
                studentPrintableRef.current
              );
            }}
          />
        </div>
      </div>

      {/* Render StudentPrintable component */}
      <div style={{ display: "none" }}>
        <StudentPrintable
          ref={studentPrintableRef}
          studentResults={studentResults}
          toggleScoreType={toggleScoreType}
          assessmentResultsByStudent={assessmentResultsByStudent}
          isPrintOut={true}
          detailedView={true}
          teacherid={teacherid}
          schoolid={schoolid}
          students={selectedStudents}
          teachers={teachers}
          classDetails={classDetails}
          hideAccordion={false}
          viewTeacher={true}
          classNotes={classNotes}
        />
        <StudentPrintable
          ref={overviewRef}
          studentResults={studentResults}
          toggleScoreType={toggleScoreType}
          assessmentResultsByStudent={assessmentResultsByStudent}
          isPrintOut={true}
          detailedView={false}
          teacherid={teacherid}
          schoolid={schoolid}
          students={selectedStudents}
          teachers={teachers}
          classDetails={classDetails}
          hideAccordion={true}
          viewTeacher={false}
        />
      </div>
    </div>
  );
};

export default ReportCardPrintActionCard;
